/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { routerActions } from 'react-router-redux';
import { injectIntl } from 'react-intl';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import PropsPanel from 'loracoms/PropsPanel';
import Nvl from 'loracoms/Nvl';
import ShowIf from 'loracoms/ShowIf';
import FormBlock from 'loracoms/FormBlock';
import gatewayActions from 'loraactions/gateway';
import enumsActions from 'loraactions/enums';
import tokenActions from 'loraactions/token';
import { compactFormat } from 'lorautils/DateTimeUtils';
import { getTokenCookies } from 'lorautils/cookies/auth';
import IntlMsg from 'lorautils/intl/IntlMsg';
import { enumsToOptions } from 'lorautils/api/selector';
import ErrorSet from 'lorautils/errors/ErrorSet';
import chplanActions from 'loraactions/chplan';
import { callAPI } from 'lorautils/api';
import styles from './styles.scss';
import MapOverlay from '../../../MapOverlay';
import { tokenOptionsSelector } from './selectors';


const propTypes = {
  intl: React.PropTypes.any.isRequired,
  gatewayId: React.PropTypes.string.isRequired,
  gateway: React.PropTypes.object.isRequired,
  gatewayData: React.PropTypes.object.isRequired,
  platOpts: React.PropTypes.array.isRequired,
  tokenOpts: React.PropTypes.array.isRequired,
  getPlatforms: React.PropTypes.func.isRequired,
  updateGateway: React.PropTypes.func.isRequired,
  getGateway: React.PropTypes.func.isRequired,
  update: React.PropTypes.object.isRequired,
  getTokens: React.PropTypes.func.isRequired,
  getChannelPlans: React.PropTypes.func.isRequired,
  channelPlans: React.PropTypes.object.isRequired,
  pushState: React.PropTypes.func.isRequired,
};

const kNonEmptyIds = [
  'name',
  'platform',
  'auth',
  'lat',
  'lng',
];


class GatewayProps extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      gateway: props.gateway,
      gatewayData: props.gatewayData,
      platOpts: props.platOpts,
      tokenOpts: props.tokenOpts,
      channelPlans: props.channelPlans,
      update: props.update,
      errors: new ErrorSet(),
    };
    this.intlMsg = new IntlMsg(props.intl, 'gatewaydetail.detailview');
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubmitLocation = this.handleSubmitLocation.bind(this);
    this.handleSubmitToken = this.handleSubmitToken.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.flushCp = this.flushCp.bind(this);
    this.loadTxPowerOpts = this.loadTxPowerOpts.bind(this);
  }

  componentWillMount() {
    const {
      getPlatforms,
      getTokens,
      getChannelPlans,
    } = this.props;
    getPlatforms();
    getTokens({ pageSize: 1000 });
    getChannelPlans({ limit: 1000 });
  }

  componentWillReceiveProps(nextProps) {
    const {
      gateway,
      platOpts,
      tokenOpts,
      gatewayData,
      update,
      channelPlans,
    } = nextProps;
    if (gateway !== this.props.gateway) {
      this.setState({ gateway });
    }
    if (platOpts !== this.props.platOpts) {
      this.setState({ platOpts });
    }
    if (tokenOpts !== this.props.tokenOpts) {
      this.setState({ tokenOpts });
    }
    if (gatewayData !== this.props.gatewayData) {
      this.setState({ gatewayData });
    }
    if (update !== this.props.update) {
      this.setState({ update });
      if (update.status === 'success') {
        const { getGateway, gatewayId } = nextProps;
        getGateway(gatewayId);
      }
    }
    if (channelPlans !== this.props.channelPlans) {
      this.setState({ channelPlans });
    }
  }

  chplanOpts() {
    const { channelPlans } = this.state;
    if (channelPlans.status !== 'success') {
      return [];
    }
    return channelPlans.data.list.map(item => ({
      label: item.name,
      value: item.id,
    }));
  }

  loadTxPowerOpts() {
    const { gatewayId } = this.props;
    callAPI({
      endpoint: `/lora/gateways/${gatewayId}/txpower`,
      method: 'GET',
    }).then((data) => {
      this.setState({ txpowerOpts: data.list.map(v => ({ value: v, label: v })) });
    }).catch(() => {});
  }

  status() {
    const disconnected = (
      <span>
        <i className="fa fa-circle-o" style={{ color: '#EF4836' }} />
        {' '}
        {this.intlMsg.msg('netstatus.status.disconnected')}
      </span>
    );
    const connected = (
      <span>
        <i className="fa fa-circle" style={{ color: '#00B16A' }} />
        {' '}
        {this.intlMsg.msg('netstatus.status.connected')}
      </span>
    );

    const { gateway } = this.state;
    const { status } = gateway;
    if (status !== 'success') {
      return disconnected;
    }

    const { data: { lastOn, lastOff } } = gateway;

    if (isNil(lastOn)) {
      return disconnected;
    }
    if (isNil(lastOff)) {
      return connected;
    }

    const onts = moment(lastOn).valueOf();
    const offts = moment(lastOff).valueOf();
    if (onts > offts) {
      return connected;
    }
    return disconnected;
  }

  lastpacket() {
    const { gatewayData: { status, data } } = this.state;
    if (status === 'pending' || status === 'request') {
      return <i className="fa fa-spinner fa-spin" />;
    }
    if (status === 'success') {
      const { list } = data;
      if (list.length > 0) {
        return compactFormat(list[0].$time);
      }
    }
    return undefined;
  }

  checkNotEmpty(val, id, errors = this.state.errors) {
    if (isNil(val) || isEmpty(val)) {
      return errors.add(
        'FE_EMPTY',
        id,
        { message: this.intlMsg.errorMsg('FE_EMPTY', 'lora') },
      );
    }
    return errors.remove(id);
  }

  handleChange(data, id) {
    const val = data[id];
    let { errors } = this.state;
    if (kNonEmptyIds.includes(id)) {
      errors = this.checkNotEmpty(val, id, errors);
    }
    this.setState({ errors });

    if (id === 'auth') {
      this.setState({ editAuth: val });
    }
  }

  handleCancel(ids) {
    let { errors } = this.state;
    ids.forEach((id) => {
      errors = errors.remove(id);
    });
    this.setState({ errors, editAuth: null });
  }

  flushCp() {
    const { gatewayId } = this.props;
    let { errors } = this.state;
    errors = errors.remove('flushcp');
    this.setState({ cpFlushStatus: 'pending', errors });
    callAPI({
      endpoint: `/lora/gateways/${gatewayId}/flushcp`,
      method: 'POST',
    }).then(() => {
      this.setState({ cpFlushStatus: 'success' });
    }).catch((error) => {
      this.setState({
        cpFlushStatus: 'failure',
        errors: errors.add(error.code, 'flushcp'),
      });
    });
  }

  handleSubmit(data, dirtyIds) {
    const { gatewayId } = this.props;

    if (isEmpty(dirtyIds)) {
      return true;
    }

    let { errors } = this.state;
    errors = errors.remove('flushcp');
    if (!errors.isEmpty()) {
      return false;
    }

    if (dirtyIds.includes('chplan')) {
      if (!_.isNil(data.chplan) && data.chplan.startsWith('unbind-')) {
        const planId = data.chplan.split('-')[1];
        callAPI({
          endpoint: `/lora/chplans/${planId}/unbind`,
          query: {
            gw: gatewayId,
          },
          method: 'POST',
        });
        this.setState({ errors: errors.remove('flushcp') });
      } else {
        callAPI({
          endpoint: `/lora/chplans/${data.chplan}/bind`,
          query: { gw: gatewayId },
          method: 'POST',
        }).then(() => {
          this.flushCp();
        }).catch(() => {});
      }
    }

    const { updateGateway } = this.props;
    const udata = { ...data };

    if (!isNil(udata.txpower)) {
      udata.txpower = +udata.txpower;
    }
    updateGateway(gatewayId, udata)
      .then(() => {})
      .catch(() => {});
    return true;
  }

  handleSubmitLocation(point) {
    const { gatewayId, updateGateway } = this.props;
    updateGateway(gatewayId, {
      lng: String(point.lng),
      lat: String(point.lat),
      alt: point.alt,
      address: point.address,
      area: point.area,
      city: point.city,
      gpssrc: 'baidu',
    });
    return true;
  }

  handleSubmitToken(data) {
    const { getGateway, gatewayId } = this.props;
    const { errors } = this.state;
    const { token } = data;
    callAPI({
      endpoint: `/lora/gateways/${gatewayId}/token`,
      method: 'POST',
      query: {
        token: _.isNil(token) ? '' : token,
      },
    }).then(() => {
      getGateway(gatewayId);
    }).catch((error) => {
      this.setState({ errors: errors.add(error.code, 'token') });
    });
    return true;
  }

  render() {
    const { gatewayId, pushState } = this.props;
    const {
      gateway: {
        status,
        data: gateway = {},
      },
      platOpts,
      tokenOpts,
      errors,
      showMap = false,
      channelPlans,
      cpFlushStatus = '',
      txpowerOpts = [],
    } = this.state;
    const {
      name,
      id,
      mac,
      platform,
      ip,
      latency,
      lastOn,
      version,
      city,
      area,
      address,
      txpower,
      token,
      lat,
      lng,
      alt,
      chplan,
    } = gateway;

    const basic = {
      name,
      id,
      mac,
      platform,
      ip,
    };
    const netStatus = {
      status: this.status(),
      latency,
      lastOn: lastOn ? compactFormat(lastOn) : undefined,
      lastpacket: this.lastpacket(),
    };
    const sdk = {
      version,
      sdkdl: (
        <a href={`/v1/lora/gateways/${gatewayId}/sdk?access_token=${getTokenCookies()}`}>
          {this.intlMsg.msg('sdk.dl')}
          {' '}
          <span className="halflings halflings-download-alt" />
        </a>
      ),
      sdkdoc: (
        <Link onClick={() => window.open('/static/docs/zh/gateway/SDKInstall.html')}>
          {this.intlMsg.msg('sdk.view')}
          {' '}
          <span className="halflings halflings-eye-open" />
        </Link>
      ),
    };
    const location = {
      city,
      area,
      address,
      lat,
      lng,
      alt,
    };
    const loraParams = {
      txpower,
      chplan,
    };
    const authData = {
      token,
    };

    const authTitle = (
      <div className="pull-left">
        {this.intlMsg.msg('auth.title')} &nbsp;
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="token">{this.intlMsg.msg('tokenmanage')}</Tooltip>}
        >
          <Link onClick={() => pushState('/accountcenter/token')}>
            <span className="glyphicons glyphicons-keys" />
          </Link>
        </OverlayTrigger>
      </div>
    );

    return (
      <div className={styles.propsPanels}>
        <PropsPanel
          title={this.intlMsg.msg('properties.title')}
          data={basic}
          status={status}
          errors={errors}
          properties={[{
            id: 'name',
            name: this.intlMsg.msg('properties.name'),
          }, {
            id: 'id',
            name: this.intlMsg.msg('properties.id'),
            readOnly: true,
          }, {
            id: 'mac',
            name: this.intlMsg.msg('properties.mac'),
            readOnly: true,
            copy: (v) => {
              if (v && v.replace) {
                return v.replace(/-/g, '');
              }
              return v;
            },
          }, {
            id: 'platform',
            name: this.intlMsg.msg('properties.platform'),
            control: {
              type: 'select',
              options: platOpts,
            },
          }, {
            id: 'ip',
            name: this.intlMsg.msg('properties.ip'),
            readOnly: true,
          },]}
          onChange={this.handleChange}
          onCancel={this.handleCancel}
          onSubmit={this.handleSubmit}
        />
        <PropsPanel
          title={this.intlMsg.msg('netstatus.title')}
          readOnly
          data={netStatus}
          status={status}
          properties={[{
            id: 'status',
            name: this.intlMsg.msg('netstatus.status'),
          }, {
            id: 'latency',
            name: this.intlMsg.msg('netstatus.latency'),
            unit: 'ms',
          }, {
            id: 'lastOn',
            name: this.intlMsg.msg('netstatus.laston'),
          }, {
            id: 'lastpacket',
            name: this.intlMsg.msg('netstatus.lastpacket'),
          }]}
        />
        <PropsPanel
          title="SDK"
          readOnly
          data={sdk}
          status={status}
          properties={[{
            id: 'version',
            value: version,
            name: this.intlMsg.msg('sdk.version'),
          }, {
            id: 'sdkdl',
            name: this.intlMsg.msg('sdk.sdkdl'),
          }, {
            id: 'sdkdoc',
            name: this.intlMsg.msg('sdk.docdl'),
          }]}
        />
        {/* <PropsPanel
          title={this.intlMsg.msg('location.title')}
          data={location}
          status={status}
          errors={errors}
          properties={[{
            id: 'city',
            name: this.intlMsg.msg('location.city'),
          }, {
            id: 'area',
            name: this.intlMsg.msg('location.area'),
          }, {
            id: 'address',
            name: this.intlMsg.msg('location.address'),
          }, {
            id: 'coordinate',
            name: this.intlMsg.msg('location.coordinate'),
            control: {
              type: 'external',
              external: (
                <Link onClick={() => this.setState({ showMap: true })}>
                  {this.intlMsg.msg('location.editcoordinate')}{' '}
                  <i className="fa fa-map-o" />
                </Link>
              ),
            },
            formatter: () => {
              let { lng: longitude = '', lat: latitude = '' } = { lng, lat };
              if (longitude === 'undefined') {
                longitude = '';
              }
              if (latitude === 'undefined') {
                latitude = '';
              }
              if (longitude !== '' && latitude !== '') {
                return (
                  <span>
                    {`(${longitude},${latitude})`}{' '}
                    <Link onClick={() => this.setState({ showMap: true })}>
                      <i className="fa fa-map-o" />
                    </Link>
                  </span>
                );
              }
              return (
                <Link onClick={() => this.setState({ showMap: true })}>
                  {this.intlMsg.msg('location.editcoordinate')}{' '}
                  <i className="fa fa-map-o" />
                </Link>
              );
            },
          }, {
            id: 'alt',
            name: this.intlMsg.msg('location.altitude'),
            readOnly: true,
          }]}
          onCancel={this.handleCancel}
          onChange={this.handleChange}
          onSubmit={this.handleSubmitLocation}
        /> */}
        <PropsPanel
          title={this.intlMsg.msg('loraparams.title')}
          data={loraParams}
          status={status}
          onEdit={this.loadTxPowerOpts}
          properties={[{
            id: 'txpower',
            name: 'TX Power',
            unit: 'dBm',
            control: {
              type: 'select',
              options: txpowerOpts,
            },
          }, {
            id: 'chplan',
            name: this.intlMsg.msg('chplan'),
            control: {
              type: 'select',
              options: [
                {
                  label: this.intlMsg.msg('chplan.unbind'),
                  value: `unbind-${chplan}`,
                  style: {
                    color: '#BDC3C7',
                  },
                },
                ...this.chplanOpts(),
              ],
            },
            formatter: x => (
              <Nvl
                status={channelPlans.status}
                val={x}
                formatter={(y) => {
                  const { data: { list = [] } = {} } = channelPlans;
                  const plan = list.find(p => p.id === y);
                  if (plan) {
                    return (
                      <div>
                        <Link onClick={() => pushState(`/network/chplans/${plan.id}`)}>{plan.name}</Link>
                        <span className={styles.flushcp}>
                          <ShowIf if={cpFlushStatus === ''}>
                            <Link onClick={this.flushCp}>
                              <i className="fa fa-cloud-download" />{' '}
                              {this.intlMsg.msg('chplan.flush')}
                            </Link>
                          </ShowIf>
                          <ShowIf if={cpFlushStatus === 'pending'}>
                            <i className="fa fa-spinner fa-spin" />
                          </ShowIf>
                          <ShowIf if={cpFlushStatus === 'success'}>
                            <i className="fa fa-check-circle text-success" />
                          </ShowIf>
                          <ShowIf if={cpFlushStatus === 'failure'}>
                            <Link onClick={this.flushCp} className="text-danger">
                              <i className="fa fa-exclamation-triangle text-danger" />{' '}
                              {this.intlMsg.msg('chplan.flush.failure')}
                            </Link>
                          </ShowIf>
                        </span>
                      </div>
                    );
                  }
                  return null;
                }}
              />
            ),
          }]}
          onCancel={this.handleCancel}
          onChange={this.handleChange}
          onSubmit={this.handleSubmit}
        >
          <div className={styles.errorBlock}>
            <FormBlock
              show={errors.has('flushcp')}
              message={this.intlMsg.errorMsg(errors.get('flushcp'))}
              azStyle="danger"
              closeButton
              onHide={() => { this.setState({ errors: errors.remove('flushcp') }); }}
            />
          </div>
        </PropsPanel>
        <PropsPanel
          title={authTitle}
          data={authData}
          status={status}
          errors={errors}
          properties={[{
            id: 'token',
            name: 'Token',
            control: {
              type: 'select',
              options: _.concat(
                {
                  label: this.intlMsg.msg('noauth'),
                  value: null,
                  formatter: x => <span className={styles.noauth}>{x}</span>,
                },
                tokenOpts),
            },
            formatter: (x) => {
              const tokenOpt = tokenOpts.find(opt => opt.value === x);
              if (tokenOpt) {
                return <span>{tokenOpt.label}</span>;
              }
              return <Nvl nul={<span className={styles.noauth}>{this.intlMsg.msg('noauth')}</span>} />;
            },
          }]}
          onCancel={this.handleCancel}
          onChange={this.handleChange}
          onSubmit={this.handleSubmitToken}
        >
          <FormBlock
            show={errors.has('token')}
            message={this.intlMsg.errorMsg(errors.get('token'))}
            azStyle="danger"
            closeButton
            onHide={() => { this.setState({ errors: errors.remove('token') }); }}
          />
        </PropsPanel>
        <MapOverlay
          gateways={[gateway]}
          show={showMap}
          onHide={() => this.setState({ showMap: false })}
          onSave={this.handleSubmitLocation}
        />
      </div>
    );
  }
}


GatewayProps.propTypes = propTypes;


const mapStateToProps = state => ({
  gateway: state.gateway.gateway || {},
  gatewayData: state.gateway.gatewayData || {},
  platOpts: enumsToOptions('platforms', state),
  tokenOpts: tokenOptionsSelector(state),
  update: state.gateway.updateGateway,
  channelPlans: state.chplan.getChannelPlans,
});

const mapDispatchToProps = ({
  pushState: routerActions.push,
  getGateway: gatewayActions.gateway,
  updateGateway: gatewayActions.updateGateway,
  getPlatforms: enumsActions.platforms,
  getTokens: tokenActions.getTokens,
  getChannelPlans: chplanActions.getChannelPlans,
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(GatewayProps));





// WEBPACK FOOTER //
// ./src/containers/Gateway/coms/GatewayDetail/coms/GatewayProps/index.jsx